import { render, staticRenderFns } from "./DamageLocatorCombined.vue?vue&type=template&id=47ecfad8&"
import script from "./DamageLocatorCombined.vue?vue&type=script&lang=ts&"
export * from "./DamageLocatorCombined.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports